var SearchBox = function (target) {
    if (!(this instanceof SearchBox)) return new SearchBox(target);

    this.body = document.querySelector("body");

    this.target = document.querySelector(target);
};

SearchBox.prototype.init = function () {
    var _context = this;
    var wrapper = document.querySelector("#UserAndBasket .sb");

    var _elem = document.createElement('div');
    var _close = document.createElement('button');

    var langCode = document.getElementById("SmallLangCode");

    var _form = document.createElement("form");
    _form.setAttribute('action', '/' + langCode.value + '/p/Cat/NewSearch');
    _form.setAttribute('autocomplete', 'off');

    _form.addEventListener('submit', function (e) {
        e.preventDefault();
        var search = e.target.querySelector("#search");
        console.log(search.value);
        if (search != undefined && search.value != '') {
            _form.submit();
        }
    });

    var _searchInput = document.createElement("input");
    _searchInput.setAttribute('name', 'sr');
    _searchInput.setAttribute('id', 'search');
    _searchInput.setAttribute('placeholder', 'Ara');
    _searchInput.setAttribute('class', 'customAutoComplete');

    //_searchInput.addEventListener("keypress", function (e) {
    //    if (e.keyCode == 13 && searchText != undefined && searchText.value != '') {
    //        _form.submit();
    //    }
    //});

    _elem.setAttribute('role', 'dialog');
    _elem.classList.add("hidden-xs");
    _elem.classList.add("hidden-sm");
    _elem.classList.add("SearchBox");
    _elem.appendChild(_close);

    _form.appendChild(_searchInput);
    _elem.appendChild(_form);

    _close.innerHTML = '';
    _close.title = 'Close';
    _close.className = 'close';
    _close.addEventListener('click', function () {
        wrapper.removeChild(_elem);
        $("#UserMenus .TopBarLinks .sb .SearchBoxBorder").removeClass("hidden-md");
    });

    _context.target.addEventListener("click", function () {
        wrapper.appendChild(_elem);
        window.elem = _elem;
    });
    $("#UserMenus .TopBarLinks .sb .SearchBoxBorder").live("click", function () {
        wrapper.appendChild(_elem);
        window.elem = _elem;
        $("#UserMenus .TopBarLinks .sb .SearchBoxBorder").addClass("hidden-md");
        $(".SearchBox #search").focus();
    });
};
